<template>
    <v-menu offset-y :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs" />
        </template>
        <v-list dense>
            <v-subheader class="template-menu-header">Templates</v-subheader>
            <v-list-item v-if="loading" disabled>
                <v-list-item-title>Loading templates…</v-list-item-title>
            </v-list-item>
            <v-list-item v-else-if="!templates || !templates.length" disabled>
                <v-list-item-title>No email templates</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="template in templates || []" :key="template.id" @click="$emit('select', template)">
                <v-list-item-title>{{ template.subject }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('select', null)">
                <v-list-item-title class="template-menu-blank">Blank email</v-list-item-title>
            </v-list-item>
            <template v-if="availability">
                <v-divider class="my-1" />
                <v-list-item @click="$emit('availability')">
                    <v-list-item-title>
                        <v-icon small color="#3988AA" class="mr-2">mdi-calendar-question</v-icon>Request Availability
                    </v-list-item-title>
                </v-list-item>
            </template>
            <template v-if="changes">
                <v-divider class="my-1" />
                <v-subheader class="template-menu-header">Booking changes</v-subheader>
                <v-list-item v-for="kind in change_kinds" :key="kind.value"
                    :disabled="kind.value === 'cancellation' && cancellationDisabled" @click="$emit('change', kind.value)">
                    <v-list-item-title>{{ kind.text }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
import { CHANGE_EMAIL_KINDS } from '@/utils/supplierChangeEmails'

// Email Supplier/s dropdown (Suppliers tab and the events lists): the company's email templates
// and "Blank email" (emits `select` with the template, or null for blank), then the booking
// change emails (emits `change` with date_change | booking_change | cancellation). With
// `availability`, "Request Availability" emits `availability` (SUPPLIER_AVAILABILITY.md).
export default {
    props: {
        templates: { type: Array, default: null },
        loading: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        // Show the booking change emails.
        changes: { type: Boolean, default: true },
        // Show "Request Availability".
        availability: { type: Boolean, default: false },
        // No deleted services to cancel.
        cancellationDisabled: { type: Boolean, default: false },
    },
    data: () => ({
        change_kinds: [
            { value: 'date_change', text: CHANGE_EMAIL_KINDS.date_change },
            { value: 'booking_change', text: CHANGE_EMAIL_KINDS.booking_change },
            { value: 'cancellation', text: `${CHANGE_EMAIL_KINDS.cancellation} (deleted services)` },
        ],
    }),
}
</script>

<style scoped>
.template-menu-header {
    font-family: Manrope;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    height: 32px;
}

.template-menu-blank {
    color: #7C7C7C;
    font-style: italic;
}
</style>
